export const enCoreMessages = {
  'common.home': 'Home',
  'common.admin': 'Admin',
  'common.cart': 'Cart',
  'common.close': 'Close',
  'common.retry': 'Retry',
  'common.logout': 'Log out',
  'common.loading': 'Loading...',
  'common.never': 'Never',
  'common.customerArea': 'Customer area',
  'common.accountDashboard': 'Account dashboard',
  'common.accountOrders': 'My orders',
  'common.accountSupport': 'Support',
  'common.goToLogin': 'Go to login',
  'common.goBack': 'Go back',
  'common.reload': 'Reload',
  'common.goCatalog': 'Back to catalog',
  'common.goHome': 'Go home',
  'common.contactSupport': 'Contact support',
  'common.language.switcherLabel': 'Language',
  'common.language.it': 'Italian',
  'common.language.en': 'English',

  'cart.preCheckout': 'Pre-checkout',
  'cart.title': 'Cart',
  'cart.continueShopping': 'Continue shopping',
  'cart.clear': 'Clear cart',
  'cart.loading': 'Loading cart...',
  'cart.emptyTitle': 'Your cart is empty',
  'cart.emptyDescription': 'Add products from the catalog to start checkout.',
  'cart.unitPrice': 'Unit price: {price}',
  'cart.remove': 'Remove',
  'cart.totalQuantity': 'Total quantity',
  'cart.subtotal': 'Subtotal',
  'cart.sidebarTitle': 'Order summary',
  'cart.sidebarItems': '{count} items in your cart',
  'cart.checkout': 'Proceed to payment',
  'cart.checkoutBusy': 'Redirecting to Stripe...',
  'cart.checkoutLoginRequired': 'Sign in as customer before starting checkout.',
  'cart.checkoutMissingCart': 'Cart unavailable. Reload the page.',
  'cart.checkoutGenericError': 'Cannot start Stripe checkout.',
  'cart.checkoutServiceUnavailable': 'Payment service is temporarily unavailable. Try again shortly.',
  'cart.checkoutTimeout': 'Checkout is taking too long. Check your orders again in a few moments.',
  'cart.checkoutViewOrdersCta': 'Go to your orders',

  'cms.page.preview': 'Draft preview',
  'cms.page.page': 'CMS page',
  'cms.page.loading': 'Loading page...',
  'cms.page.unavailable': 'Page unavailable.',
  'cms.page.badge.published': 'Published',
  'cms.page.badge.draft': 'Draft',
  'cms.page.badge.preview': 'Preview',

  'home.fallback.shopFrontend': 'Shop frontend',
  'home.fallback.cart': 'Cart',
  'home.fallback.adminArea': 'Restricted area',

  'error.unknownEyebrow': '{code} · Error',
  'error.unknownTitle': 'Unexpected scenario',
  'error.unknownDescription': 'An unclassified error occurred.',

  'error.401.eyebrow': '401 · Unauthorized',
  'error.401.title': 'Double-locked door',
  'error.401.description': 'This area requires authentication. Check login or token and retry.',
  'error.403.eyebrow': '403 · Forbidden',
  'error.403.title': 'Insufficient permission',
  'error.403.description': 'You reached the page, but you do not have enough privileges.',
  'error.404.eyebrow': '404 · Resource not found',
  'error.404.title': 'Oops, the requested resource was not found',
  'error.404.description': 'Check the URL or return to the homepage to continue browsing.',
  'error.418.eyebrow': '418 · Teapot mode',
  'error.418.title': 'The teapot refuses to brew coffee',
  'error.418.description': 'Ironic test error, useful for UI and route checks.',
  'error.500.eyebrow': 'Temporary issue',
  'error.500.title': 'Something did not respond as expected',
  'error.500.description':
    'We are having a temporary issue loading this page. Try again in a few seconds or return to the homepage.',
  'error.500.referenceLabel': 'Reference',
  'error.503.eyebrow': '503 · Service unavailable',
  'error.503.title': 'Workshop temporarily busy',
  'error.503.description': 'The service is temporarily unavailable or under maintenance.',
} as const
